(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

$(document).ready(function(){
  $(".landingpagetextslider").owlCarousel({
    loop:true, // Enable looping
    margin:40, // Margin between items
    dots: false,
    autoplay: true,
    responsive:{ // Responsive options for different screen sizes
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:3.3
        }
    }
  });
});

$(document).ready(function(){
  $(".landingpagemostdays").owlCarousel({
    loop:true, 
    margin:40,
    dots: false,
    autoplay: true,
    responsive:{ 
        0:{
            items:1.15,
            margin:16
        },
        500:{
            items:1.2,
            margin:16
        },
        767:{
            items:1.4,
            margin:16
        },
        1023: { 
          items: 1.4
        }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  
$(document).ready(function () {
  var $owl = $(".moodchewslider");

  $owl.owlCarousel({
    nav: true,
    navText: ["Previous", "Next"],
    loop: true,
    dots: true, // Required to get centered .owl-dots container
    items: 3,
    margin: 32,
    autoplay: false,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      769: { items: 1 },
      1024: { items: 1.06 },
      1200: { items: 1.15 },
      1280: { items: 1.3 },
      2560: { items: 1.5 }
    },
    onInitialized: updateDots,
    onChanged: updateDots
  });

  function updateDots(event) {
    var carousel = event.relatedTarget;
    var total = carousel.items().length;
    var current = carousel.relative(carousel.current()) + 1;

    var $dotsContainer = $owl.find('.owl-dots');

    // Replace contents with just a number
    $dotsContainer.html('<div class="owl-dot number-indicator active">' + current + '/' + total + '</div>');
  }
});

  
$(document).ready(function () {
    $('#see-science').on('click', function (e) {
      e.preventDefault();
      $('#how-popup').css('display', 'flex'); // Or .fadeIn() if using transitions
    });
});

$(document).ready(function () {
    $('#close-howpopup').on('click', function (e) {
      e.preventDefault();
      $('#how-popup').css('display', 'none'); // Or use .fadeOut() if needed
    });
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-after-fog"] && !Shopify.designMode) return;
  try {
    
  
$(document).ready(function () {
  var $owl = $(".life-after-fog-slider");

  $owl.owlCarousel({
    nav: true,
    navText: ["Previous", "Next"],
    loop: true,
    margin: 20,
    dots: true, // Required to get centered .owl-dots container
    items: 3,
    autoplay: false,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      769: { items: 1 },
      1000: { items: 4 }
    },
    onInitialized: updateDots,
    onChanged: updateDots
  });

  function updateDots(event) {
    var carousel = event.relatedTarget;
    var total = carousel.items().length;
    var current = carousel.relative(carousel.current()) + 1;

    var $dotsContainer = $owl.find('.owl-dots');

    // Replace contents with just a number
    $dotsContainer.html('<div class="owl-dot number-indicator active">' + current + '/' + total + '</div>');
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-we-exist"] && !Shopify.designMode) return;
  try {
    
  
$(document).ready(function () {
  var $owl = $(".moodchewslider");

  $owl.owlCarousel({
    nav: true,
    navText: ["Previous", "Next"],
    loop: true,
    margin: 20,
    dots: true, // Required to get centered .owl-dots container
    items: 3,
    autoplay: false,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      769: { items: 1 },
      1000: { items: 1.45 }
    },
    onInitialized: updateDots,
    onChanged: updateDots
  });

  function updateDots(event) {
    var carousel = event.relatedTarget;
    var total = carousel.items().length;
    var current = carousel.relative(carousel.current()) + 1;

    var $dotsContainer = $owl.find('.owl-dots');

    // Replace contents with just a number
    $dotsContainer.html('<div class="owl-dot number-indicator active">' + current + '/' + total + '</div>');
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-mobile"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  var $owl = $(".why-choose-mobile");

  $owl.owlCarousel({
    nav: true,
    navText: ["Previous", "Next"],
    loop: true,
    margin: 20,
    dots: true,
    items: 3,
    autoplay: false,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      769: { items: 1 },
      1000: { items: 1.45 }
    },
    onInitialized: updateDots,
    onChanged: updateDots
  });

  function updateDots(event) {
    var carousel = event.relatedTarget;
    var total = carousel.items().length;
    var current = carousel.relative(carousel.current()) + 1;

    var $dotsContainer = $owl.find('.owl-dots');

    $dotsContainer.html('<div class="owl-dot number-indicator active">' + current + '/' + total + '</div>');
  }
});

  } catch(e) { console.error(e); }
})();
})();
